/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Detailed breakdown of a specific time period (e.g., a month)
 */
export interface MandatePlanningSegment {
  periodStartLocal: string;
  periodEndLocal: string;
  availableSlots: number;
  isFilled: boolean;
}
